export function responsiveImageSet(src, widths = [640, 960, 1280], sizes = "100vw") {
  const base = String(src || "").replace(/\.(png|jpg|jpeg|webp)$/i, "");
  const ext = String(src || "").split(".").pop();
  const fallbackExt = ext === "webp" ? "jpg" : ext;
  return {
    src,
    avifSrcSet: widths.map((width) => `${base}-${width}.avif ${width}w`).join(", "),
    webpSrcSet: widths.map((width) => `${base}-${width}.webp ${width}w`).join(", "),
    fallbackSrcSet: widths.map((width) => `${base}-${width}.${fallbackExt} ${width}w`).join(", "),
    sizes,
  };
}


export const HERO_IMAGE = {
  src: "/media/hero/rmc-hero-960.jpg",
  avifSrcSet: "/media/hero/rmc-hero-640.avif 640w, /media/hero/rmc-hero-960.avif 960w, /media/hero/rmc-hero-1312.avif 1312w",
  webpSrcSet: "/media/hero/rmc-hero-640.webp 640w, /media/hero/rmc-hero-960.webp 960w, /media/hero/rmc-hero-1312.webp 1312w",
  fallbackSrcSet: "/media/hero/rmc-hero-640.jpg 640w, /media/hero/rmc-hero-960.jpg 960w, /media/hero/rmc-hero-1312.jpg 1312w",
  sizes: "(max-width: 1023px) calc(100vw - 2rem), 520px",
};

export const RMC_LOGO_IMAGE = {
  src: "/media/logos/rmc-logo-400.png",
  avifSrcSet: "/media/logos/rmc-logo-240.avif 240w, /media/logos/rmc-logo-400.avif 400w, /media/logos/rmc-logo-800.avif 800w",
  webpSrcSet: "/media/logos/rmc-logo-240.webp 240w, /media/logos/rmc-logo-400.webp 400w, /media/logos/rmc-logo-800.webp 800w",
  fallbackSrcSet: "/media/logos/rmc-logo-240.png 240w, /media/logos/rmc-logo-400.png 400w, /media/logos/rmc-logo-800.png 800w",
  sizes: "(max-width: 640px) 180px, 392px",
};

export const PARTNERS_IMAGE = {
  src: "/media/partners/partners-960.png",
  avifSrcSet: "/media/partners/partners-640.avif 640w, /media/partners/partners-960.avif 960w, /media/partners/partners-1255.avif 1255w",
  webpSrcSet: "/media/partners/partners-640.webp 640w, /media/partners/partners-960.webp 960w, /media/partners/partners-1255.webp 1255w",
  fallbackSrcSet: "/media/partners/partners-640.png 640w, /media/partners/partners-960.png 960w, /media/partners/partners-1255.png 1255w",
  sizes: "(max-width: 768px) calc(100vw - 2rem), 1024px",
};
